import { trpc } from '@/shared/api';

/** 설명은 운영자가 드물게 고친다 — 가이드를 여닫을 때마다 다시 묻지 않는다. */
const GUIDE_STALE_MS = 10 * 60_000;

/** 프린트 가이드(printMethods.listGuide) — 전체 인쇄 방식의 이름·설명, 이름순. 비로그인 허용. */
export const usePrintMethodGuideQuery = (options: { readonly enabled: boolean }) =>
  trpc.printMethods.listGuide.useQuery(undefined, {
    enabled: options.enabled,
    staleTime: GUIDE_STALE_MS,
    retry: false,
  });
